const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');
const ErrorMessage = require('components/shared/error_message.jsx');

class PaypalProfile extends React.Component {
  get profileContainerClass() {
    return classNames(
      { 'global-slidedown--open': this.props.selected },
      { 'global-slidedown--closed': !this.props.selected }
    );
  }

  completedProfile() {
    return (
      <div dangerouslySetInnerHTML={{ __html: this.props.paypalAccountLink }}></div>
    );
  }

  nameForField(fieldName) {
    return `${this.props.formPrefix}[${fieldName}]`;
  }

  profileForm() {
    return (
      <div>
        {this.renderErrorMessage()}
        <div className="form-group mb-0">
          <div className="form-group__header">
            <label htmlFor={this.nameForField('email')}>
              {I18n.t('js.dashboard.selling.shopPolicies.paypalEmailLabel')}
            </label>
          </div>
          <div className="form-group__fields">
            <input
              value={this.props.userAttributes.firstName}
              type="hidden"
              name={this.nameForField('first_name')}
            />
            <input
              value={this.props.userAttributes.lastName}
              type="hidden"
              name={this.nameForField('last_name')}
            />
            <input
              required="required"
              type="text"
              name={this.nameForField('email')}
              id={this.nameForField('email')}
            />
          </div>
        </div>
      </div>
    );
  }

  renderErrorMessage() {
    if (this.props.errorMessages.length === 0) {
      return false;
    }

    return (
      <ErrorMessage
        alertStyle="alert-error alert-small"
        message={this.props.errorMessages.join('. ')}
      />
    );
  }

  renderProfile() {
    if (this.props.initiallyReadOnly) {
      return this.completedProfile();
    }
    return this.profileForm();
  }

  render() {
    return (
      <div
        className={this.profileContainerClass}
        data-paypal-profile-form
      >
        <div className={this.props.classNames}>
          {this.renderProfile()}
        </div>
      </div>
    );
  }
}

PaypalProfile.propTypes = {
  initiallyReadOnly: PropTypes.bool.isRequired,
  paypalAccountLink: PropTypes.string,
  userAttributes: PropTypes.object.isRequired,
  formPrefix: PropTypes.string.isRequired,
  errorMessages: PropTypes.array.isRequired,
  classNames: PropTypes.string,
  selected: PropTypes.bool,
};

PaypalProfile.defaultProps = {
  classNames: 'margined-left mobile-mt-1 module panel',
};

module.exports = PaypalProfile;



// WEBPACK FOOTER //
// ./javascripts/components/shop/paypal_profile.jsx